module.exports = __webpack_public_path__ + "img/reliance_digital.f374dc45.svg";